<template>
  <label>
    <slot>
      <span v-html="text"/>
    </slot>
  </label>
</template>

<script>
export default {
  props: ['text'],
}
</script>



// WEBPACK FOOTER //
// src/components/base/Label.vue